// extracted by mini-css-extract-plugin
export default {"ordersGroup__divider":"BagDetail_ordersGroup__divider__+os9j","ordersGroup__byHour":"BagDetail_ordersGroup__byHour__VbyF0"};